import { Collapse, Table, Text, TextInput } from '@mantine/core';
import { IconSearch } from '@tabler/icons-react';
import { useEffect, useState } from 'react';

const MergeTagsCollapsible = function (props) {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredTags = props.mergeTags
    ? props.mergeTags.filter(
        (tag) =>
          tag.pattern.toLowerCase().includes(searchTerm.toLowerCase()) ||
          tag.label.toLowerCase().includes(searchTerm.toLowerCase())
      )
    : [];

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  useEffect(() => {
    if (!props.open) {
      setSearchTerm('');
    }
  }, [props.open]);

  if (!props.mergeTags) {
    return '';
  }

  return (
    <>
      <Collapse expanded={props.open}>
        <div>
          <TextInput
            placeholder="Search merge tags..."
            value={searchTerm}
            onChange={handleSearchChange}
            size="sm"
            mb="sm"
            leftSection={<IconSearch size={16} />}
          />
          <Table striped withTableBorder highlightOnHover>
            <Table.Thead>
              <Table.Tr>
                <Table.Th>Pattern</Table.Th>
                <Table.Th>Label</Table.Th>
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody>
              {filteredTags.length > 0 ? (
                filteredTags.map((tag) => (
                  <Table.Tr key={tag.key}>
                    <Table.Td>{tag.pattern}</Table.Td>
                    <Table.Td>{tag.label}</Table.Td>
                  </Table.Tr>
                ))
              ) : (
                <Table.Tr>
                  <Table.Td colSpan={2}>
                    <Text ta="center" c="dimmed">
                      {searchTerm ? `No merge tags found matching "${searchTerm}"` : 'No merge tags available'}
                    </Text>
                  </Table.Td>
                </Table.Tr>
              )}
            </Table.Tbody>
          </Table>
        </div>
      </Collapse>
    </>
  );
};

export default MergeTagsCollapsible;
